const isBrowser = typeof window !== 'undefined'

export const getEnvLevel = () => {
  if (!isBrowser) return 'dev'
  const host = window.location.host
  if (host === 'lighthouse.allstate.com') return 'prod'
  if (host.startsWith('lighthouse-preprod')) return 'preprod'
  if (host.startsWith('lighthouse-uat')) return 'uat'
  return 'dev'
}

export const getLocationEndpoint = () => {
  if (isBrowser && window.location.href.includes('localhost')) {
    return 'http://localhost:8080/v1/lighthouse/locations'
  }
  return '/v1/lighthouse/locations'
}
